import { ParOfferResponse } from '../../../services/pricing';
import { PropElementRequest } from '../../../services/proposal';
import moment from 'moment';
import { pricingAttributeToElementAttribute } from './pricingAttributeToElementAttribute';
import { offerPrefinstepToElementStep } from './offerPrefinstepToPrefinElementStep';

export function offerToElement(
  data: ParOfferResponse,
  investamount: number,
  vatamount: number,
  rvamount: number,
  assetParticipation: boolean,
  partmethod: string,
  partamount: number,
  cteid: number,
  ctfclevel?: string,
  assetid?: number,
  ctecategory?: string,
  ctecategorylabel?: string,
  ctedirection?: string,
  ctemileage?: number,
  ctepriidexceed?: number,
): PropElementRequest {
  // SERV = serviceduration ==> ctecalculationtype
  // SERV = servicecalculationmethod ==> ctecalculationbasis
  // FIN = calculationmethod ==>ctecalculationtype

  //const investamount=asset.assetnetamount;

  let _ctedirection = ctedirection ?? 'IN';

  if (_ctedirection === 'REFIN') {
    _ctedirection = 'OUT';
  } else {
    _ctedirection = 'IN';
  }


  const cupfront =
    (((data.upfrontdefault ?? 0) as number) * investamount) / 100;
  const cpart = assetParticipation
    ? partamount
    : data.partamount
    ? (data.partrate * investamount) / 100
    : 0;

  const part = isNaN(cpart) ? 0 : cpart;
  const upfront = isNaN(cupfront) ? 0 : cupfront;

  const finamount = investamount - upfront - part;
  const firtspayment = (data.firstrentaldefault * investamount) / 100;
  //const rvamount=data.rvdefault?data.rvdefault*investamount/100:data.rvdefaultamount;
  console.log(
    'finamount : ',
    finamount,
    investamount,
    upfront,
    part,
    data.upfrontdefault
  );
  return {
    conElemAttributes: data.attributeList
      ? pricingAttributeToElementAttribute(data.attributeList)
      : [],
    offer: { ofrid: 0, ofrtype: '', ofrlabel: '', ofrdescription: '' },
    ofrid: 0,
    ofrlabel: '',
    ofrtype: '',
    cteid: cteid,
    ctrid: 0,
    cteorder: 1,
    ctedirection: _ctedirection,
    ctetype: 'FIN',

    ctecategory: ctfclevel === 'MOASSMUEL' ? ctecategory ?? 'ELEMASSET' : 'FIN',
    ctecategorylabel:
      ctfclevel === 'MOASSMUEL'
        ? ctecategorylabel ?? 'Element linked to asset'
        : 'Financial',
    ctestatus: 'INIT',
    ctebilligdate: data.ctebilligdate ?? '05',
    ctedescription: data.offerlabel,
    tpid: 0, //TODO
    priid: 0, //firstFinElement.priid,
    pritype: '',
    assetid: assetid ?? 0, //asset.assetid,
    currcode: data.currcode,
    taxcode: data.taxcode,
    taxrate: data.taxrate,
    taxtype: data.taxtype,
    ctestartdate: moment(),
    cteenddate: '',
    ctecalculationtype: data.calculationmethod,
    ctecalculationbasis: data.calculationbasis, // only for services :
    cteinitialamount: finamount,
    cteupfrontamount: upfront,
    cteinvestamount: investamount,
    ctefinancedamount: finamount,
    ctestartamount: finamount,
    cteendamount: rvamount,
    ctepaymentterm: data.term,
    cteinterestmethod: data.interestmethod,
    cteperiodicity: data.periodicity,
    cteunit: data.unit,
    cteduration: data.durationdefault,
    ctedeferredinterestmethod: data.deferredinterestmethod,
    ctegraceperiodduration: data.gpduration,
    ctegraceperiodmethod: data.gpmethod,
    ctervcoef: data.rvdefault,
    ctervamount: rvamount,
    rvcalculationmode: data.rvcalculationmode,
    rvevaluationmode: data.rvevaluationmode,
    prefinrateref: data.prefinnominalrate,
    prefinratespread: 0,
    cterateref: data.ratevaluedefault,
    ctefirstpayment: firtspayment,
    ctefirstpaymentcoef: data.firstrentaldefault,
    cteinstallmentamount: 0, //response.installmentamount,
    ctedepositamount:
      data.depositamount === 0 && data.depositcoef > 0
        ? investamount / data.depositcoef
        : data.depositamount,
    ctedepositcoef: data.depositcoef,
    ctedepositinterestmethod: data.depositinterestmethod,
    ctedepositnominalrate:
      data.depositratetype === 'CONTRACT'
        ? data.ratespreaddefault + data.ratevaluedefault
        : data.depositnominalrate,
    ctedeferredinterestnominalrate:
      data.deferredinterestratetype === 'CONTRACT'
        ? data.ratespreaddefault + data.ratevaluedefault
        : data.deferredinterestnominalrate,
    ctemileage: ctemileage ?? 0,
    ctepriidexceed: ctepriidexceed ?? 0,    
    servbasis: 0,
    cteratetype: data.ratetype,
    cterateformula: data.rateformula,
    cterateterm: '', // to remove
    cteratebasis: data.calculationbasis,
    cterateperiodicity: String(data.rateperiodicity),
    cteactuarialrate: 0,
    ctenominalrate: data.ratespreaddefault + data.ratevaluedefault,
    depositratetype: data.depositratetype,
    deferredinterestratetype: data.deferredinterestratetype,
    cteratespread: data.ratespreaddefault,
    ctepartmethod: assetParticipation ? partmethod : data.partmethod,
    ctepartamount: assetParticipation
      ? part
      : data.partmethod === 'FIXED'
      ? data.partamount
      : (data.partrate * investamount) / 100,
    ctepartrate: assetParticipation
      ? (part / investamount) * 100
      : data.partmethod === 'FIXED' || data.partmethod === 'WSPART'
      ? data.partrate === 0
        ? (data.partamount / investamount) * 100
        : data.partrate + data.partratespread
      : data.partrate + data.partratespread,
    ctepartdays: data.partnbdays,

    tpidparticipation: {
      tpreference: data?.tpreferenceparticipation,
      tpname: data.tpnameparticipation,
      tpid: data.tpidparticipation,
    },

    ctedeferredinterest: 0,
    ctedepositinterest: 0,
    cterentalamount: 0,
    conElemSchedules: [],
    conElemServiceSteps: [],
    conElemAssets: [],
    additionalcostaftermargin: 0,
    servfixedamount: 0,
    servpercentage: 0,
    calculatedamountbasis: '',
    conElemSteps: [],
    conElemPrefinSteps: data?.prefinStepList
      ? offerPrefinstepToElementStep(data?.prefinStepList, finamount)
      : [],
    ctefirstpaymentdate: '',
    ctefree1: '',
    cteidparent: 0,
    last_action: '',
    marginoncalulatedcamount: 0,
    prefinbasis: data.prefinbasis,
    prefinmethod: data.prefinmethod,
    prefinnominalrate: data.prefinnominalrate,
    prefinperiodicity: data.prefinperiodicity,
    prefinrateformula: data.prefinrateformula,
    prefinratetype: data.prefinratetype,
    helpers: {
      servfixedamountmin: 0,
      servpercentagemin: 0,
      servcontextmin: 0,
      durationmax: data.durationmax ? data.durationmax : 120,
      durationmin: data.durationmin ? data.durationmin : 0,
      //durationdefault: data.durationdefault ? data.durationdefault : 0,
      frmin: data.firstrentalmin ? data.firstrentalmin : 0,
      frmax: data.firstrentalmax ? data.firstrentalmax : 0,
      upmax: data.upfrontmax ? data.upfrontmax : 0, //50,
      upmin: data.upfrontmin ? data.upfrontmin : 0,
      rvmax:
        data.rvcalculationmode === 'ASSET'
          ? (rvamount / investamount) * 100
          : data.rvcalculationmode === 'ASSETADJ'
          ? (data.rvmax / investamount) * 100
          : data.rvmax
          ? data.rvmax
          : 50,
      rvmin:
        data.rvcalculationmode === 'ASSET'
          ? (rvamount / investamount) * 100
          : data.rvcalculationmode === 'ASSETADJ'
          ? (data.rvmin / investamount) * 100
          : data.rvmin
          ? data.rvmin
          : 0,
      rvcontextmax:
        data.rvcalculationmode === 'ASSET'
          ? (Number(rvamount) / investamount) * 100
          : data.rvcalculationmode === 'ASSETADJ'
          ? (Number(data.rvcontextmax) / investamount) * 100
          : data.rvcontextmax
          ? data.rvcontextmax
          : 50,
      rvcontextmin:
        data.rvcalculationmode === 'ASSET'
          ? (Number(rvamount) / investamount) * 100
          : data.rvcalculationmode === 'ASSETADJ'
          ? (Number(rvamount) / investamount) * 100
          : data.rvcontextmin
          ? data.rvcontextmin
          : 0,
      ratecontextmin: data.ratecontextmin
        ? data.ratevaluedefault + data.ratecontextmin
        : data.ratevaluedefault + data.ratespreadmin,
      ratecontextmax: data.ratecontextmax
        ? data.ratevaluedefault + data.ratecontextmax
        : data.ratevaluedefault + data.ratespreadmax,

      frcontextmax: data.frcontextmax,
      frcontextmin: data.frcontextmin,
      durationcontextmax: data.durationcontextmax,
      durationcontextmin: data.durationcontextmin,
      marginratemin: data.marginratemin,
      margincontextmin: data.margincontextmin,
      marginratemax: data.marginratemax,
      margincontextmax: data.margincontextmax,

      gpdurationmax: data.gpduration ? data.gpduration : 0,
      gpmin: data.gpmin ?? 0,
      gpmax: data.gpmax ?? 15,
      ratemax:
        data.ratevaluedefault != null
          ? data.ratevaluedefault + data.ratespreadmax
          : 30,
      ratemin:
        data.ratevaluedefault != null
          ? data.ratevaluedefault + data.ratespreadmin
          : 1,
      partnbdaysmax: data.partnbdaysmax,
    },
    spvassetdiscount: data.spvassetdiscount,
    spvriskrate: data.spvriskrate,
    spvadditionalfees: data.spvadditionalfees,
    spvloancoef: data.spvloancoef,
    spvdiscountsale: data.spvdiscountsale,
    spvinflation: data.spvinflation,
    spvassetdiscountamount: 0,
    spvloanamount: 0,
    spvriskamount: 0,
    spvfeesamount: 0,
    serviceResponse: {} as any,
    commissionResponse: {} as any,
    serviceStepList: [],
    pricingStepList: [],
    pricing: {} as any,
    rvauthid: data.rvauthid,
    rvtaskid: data.rvtaskid,
    rateauthid: data.rateauthid,
    ratetaskid: data.ratetaskid,
    frauthid: data.frauthid,
    frtaskid: data.frtaskid,
    durationauthid: data.durationauthid,
    durationtaskid: data.durationtaskid,
    servtaskid: data.servtaskid,
    servauthid: data.servauthid,
    margintaskid: data.margintaskid,
    marginauthid: data.marginauthid,
    ctefeesamount: 0,
    ctecommissionamount: 0,
    cteprofitabilityrate: 0,
    cteaprrate: 0,
    cteflatrate: 0,
    ctecoefrate: 0,
    ctefundingrate: 0,
    ctefundingperiodicity: 0,
    ctefundinginstallment: 0,
    ctefundingcost: 0,
    ctemarginamount: 0,
    ctemarginrate: 0,
    ctevatdeferralamount: vatamount,
    ctevatdeferralduration: 0,
    ctevatdeferralmethod: 'NONE',
    ctevatdeferraldaysbasis: '365',
    cteextracosttofinance: 0,
    cteextracostcomment: '',
    totalInterest: 0,
    totalRental: 0,
    totalAmortization: 0,
    totaldiscountedInterest: 0,
    totalVatDeffered: 0,
    totaldiscountedOutstanding: 0,
    totaldiscountedAgiosdeb: 0,
    totalAgiosdeb: 0,
    marginImpactCredit: 0,
    marginImpactDebit: 0,
    dgo: 0,
    profitabilityAmount: 0,
    ceilingrate: data.ceilingrate,
    ceilingdefaultrate: data.ceilingdefaultrate,
    floorrate: data.floorrate,
    floordefaultrate: data.floordefaultrate,
    calid: data.calid,
    ctepartratetype: data.partratetype,
    ctepartrateformula: data.partrateformula,
    ctepartinvoicingmode: data.partinvoicingmode,
    ctepartratespread: data.partratespread,
    ctepartratedefault: data.partrate,
    servdescription: '',
    servusecoverage: 0,
    servusedeductionamount: 0,
    servusedeductionpercenrage: 0,
    servusefrequency: '',
    servusemaxamount: 0,
    servuseminamount: 0,
    servuseqty: 0,
    servuseunit: '',
  };
}
